import React from 'react';
import css from './Sections.module.css';
import people from '../../../../assets/people.jpg';
import classNames from 'classnames';
import {
  ArrowRightOutlined,
} from '@ant-design/icons';
import { Button } from 'antd';
import { NamedLink, PrimaryButton, SecondaryButtonInline } from '../../../../components';
import { createResourceLocatorString } from '../../../../util/routes';

function SectionCTA(props) {
  const { history, routeConfiguration } = props;

    const redirectToSignupPage = () => {
      history.push(createResourceLocatorString('SignupPage', routeConfiguration, {}));
    };
  
    const redirectToAboutUsPage = () => {
      history.push('/about');
    };

  return (
    <div className={classNames(css.sectionAbout, css.sectionCTA)}>
      <div className={css.fixedWidthContainer}>
      <img src={people} alt='Start growing with Parley' />
        <div className={css.sectionHeader}>
          <h1>Start growing with Parley</h1>
          <p>Join over 4,000+ startups already growing with Parley.</p>
        </div>
        <div className={css.sectionContent}>
          <div className={css.heroButtonSec}>            
            <Button size="large" onClick={redirectToAboutUsPage}>About Us</Button>
            <Button size="large" type="primary" icon={<ArrowRightOutlined />} iconPosition="end" onClick={redirectToSignupPage}>Get Started</Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SectionCTA;
